const errorCode = {
  4000100: 'Yêu cầu không hợp lệ',
  4000101: 'Token chưa được xác minh',
  4000102: 'Lỗi hệ thống',
  4000103: 'Thông tin người dùng đã tồn tại',
  4000104: 'Role đã tồn tại',
  4000105: 'Team đã tồn tại',
  4000106: 'Thông tin dạng số và bắt đầu bằng 1.',
  4000107: 'Lỗi hệ thống',
  4000108: 'Lỗi hệ thống',
  4000110: 'File không được hỗ trợ',
  4000111: 'User chưa được phân quyền',
  4000112: 'SĐT không hợp lệ',
  4000113: 'Không có thông tin người dùng',
  4000114: 'Không tìm thấy role',
  4000115: 'Thông tin sắp xếp chưa hợp lệ',
  4000116: 'Tiêu đề chỉ sử dụng các ký tự chữ, số và không chứa ký tự đặc biệt',
  4000117: 'Tiêu đề chỉ được phép chứa tối đa 30 ký tự.',
  4000118: 'Mô tả chỉ được phép chưa tối đa 2500 ký tự',
  4000119: 'Tên lối tắt đã tồn tại!',
  4000120: 'Tên URL đã tồn tại!',
  4000121: 'Lỗi hệ thống',
  4000122: 'Lỗi hệ thống',
  4000123: 'Lỗi hệ thống',
  4000124: 'Lỗi hệ thống',
  4000125: 'Lỗi hệ thống',
  4000126: 'Tạo mới thông tin người dùng không thành công',
  4000127:
    'Mô tả chỉ sử dụng các ký tự chữ, số,  không chứa ký tự đặc biệt và 1 khoảng trắng giữa mỗi từ',
  4000128: 'Call API lỗi, vui lòng thử lại sau 30s',
  4000129: 'Chỉ được phép chứa tối đa 30 ký tự',
  4000130: 'Chỉ sử dụng các ký tự chữ, số, không chứa ký tự đặc biệt và 1 khoảng trắng giữa mỗi từ',
  4000131: 'Không được phân quyền. Vui lòng thử lại',
  4000132: 'Lỗi hệ thống',
  4000133: 'Chỉ sử dụng các ký tự chữ, số, không chứa ký tự đặc biệt và 1 khoảng trắng giữa mỗi từ',
  4000134: 'Chỉ được phép chứa tối đa 250 ký tự',
  4000135: 'Lỗi hệ thống',
  4000136: 'Role code phải là một chuỗi ký tự số. Vui lòng kiểm tra và thử lại',
  4000137: 'Mô tả phải các ký tự chữ. Vui lòng kiểm tra và thử lại',
  4000138: 'Điều kiện không hợp lệ. Hãy đảm bảo bạn đã điền đúng điều kiện',
  4000139: 'Điều kiện không được để trống. Vui lòng nhập điều kiện cần thiết',
  4000140: 'Lỗi hệ thống',
  4000141: 'Lỗi hệ thống',
  4000142: 'Màu sắc phải là duy nhất. Hãy đảm bảo không có màu nào bị trùng lặp',
  4000143: 'Giá trị không hợp lệ. Vui lòng kiểm tra lại và nhập giá trị đúng',
  4000144: 'Không được để trống màu sắc. Vui lòng chọn màu cần thiết',
  4000145: 'Đã xảy ra lỗi khi tạo hoặc cập nhật tiêu đề người dùng. Vui lòng thử lại',
  4000146: 'Đã xảy ra lỗi khi xóa tiêu đề người dùng. Vui lòng thử lại',
  4000147: 'Đã xảy ra lỗi khi lấy danh sách người dùng. Vui lòng thử lại',
  4000148: 'Mức độ ưu tiên không được hỗ trợ',
  4000149: 'Nhóm công việc không được hỗ trợ',
  4000150: 'Không tìm thấy cấu hình thông tin công việc',
  4000151: 'Không có quyền chỉnh sửa',
  4000152: 'Yêu cầu công việc không hợp lệ',
  4000153: 'Trạng thái công việc không được hỗ trợ',
  4000201: 'Số điện thoại đã tồn tại. Vui lòng kiểm tra lại',
  4000202: 'Cần có ID của SĐT. Vui lòng cung cấp.',
  4000203: 'Lỗi hệ thống',
  4000204: 'Lỗi hệ thống',
  4000205: 'Lỗi hệ thống',
  4000206: 'Lỗi hệ thống',
  4000207: 'Lỗi hệ thống',
  4000208: 'Tên không hợp lệ. Vui lòng kiểm tra lại',
  4000301: 'Account không hợp lệ. Vui lòng kiểm tra lại',
  4000302: 'Phiên đăng nhập hết hạn. Vui lòng thử lại',
  4000303: 'Lỗi hệ thống',
  4000304: 'Lỗi hệ thống',
  4000305: 'Thông tin đã tồn tại. Vui lòng kiểm tra và thử lại',
  4000400: 'Lưu thất bại. Vui lòng kiểm tra lại',
  4000401: 'Lỗi hệ thống',
  4000402: 'Lỗi định dạng thời gian',
  4000403: 'Không được bỏ trống bất kỳ trường thông tin nào',
  4000404: 'Thời gian chưa đúng định dạng. Vui lòng kiểm tra lại',
  4000405: 'Lỗi hệ thống',
  4000406: 'Lỗi hệ thống',
  4000407: 'Lỗi hệ thống',
  4000408: 'Thời gian chưa đúng định dạng. Vui lòng kiểm tra lại',
  4000409: 'Thời gian bắt đầu không được lớn hơn thời gian kết thúc',
  4000410: 'Ticket không tồn tại. Vui lòng kiểm tra và thử lại',
  4000411: 'Không được bỏ trống thời gian tạo',
  4000412: 'Chỉ được chọn tối đa là 10. Vui lòng thử lại',
  4000413: 'Lỗi hệ thống',
  4000414: 'Lỗi hệ thống',
  4000415: 'Đồng bộ trạng thái Ticket không thành công. Vui lòng báo admin',
  4000416: 'Lỗi hiển thị thông tin chi nhánh',
  4000417: 'Lỗi hiển thị thông tin queue. Vui lòng thử lại',
  4000418: 'Lỗi hiển thị Ticket. Vui lòng reload lại trang',
  4000419: 'Webhook chỉ nhạn mã Ticket. Vui lòng thông báo cho admin',
  4000420: 'Đồng bộ Ticket không thành công. Vui lòng kiểm tra lại',
  4000421: 'Lỗi hệ thống',
  4000422: 'Tạo hoặc update thông tin call Sự cố lớn thất bại',
  4000423: 'Không tìm thấy thông tin cuộc gọi tương ứng cho Ticket',
  4000425: 'Không tìm thấy thông tin Ticket',
  4000426: 'Lỗi hệ thống',
  4000427: 'Call tối thiểu mỗi đơn vị 1 nhân sự',
  4000428: 'Thời gian update thông tin tối đa là 4 giờ.',
  4000429: 'Lỗi hệ thống',
  4000430: 'Không thể cập nhật khi quá 50% thời gian',
  4000431: 'Hiển thị số lượng ticket sự cố lớn chưa được khai báo sai. Vui lòng báo admin',
  4000432: 'Thời gian cập nhật không được bỏ trống.',
  4000501: 'Khoảng thời gian không tồn tại. Vui lòng kiểm tra và thử lại',
  4000503: 'Keywork tìm kiếm không hợp lệ. Vui lòng thử lại',
  4000600: 'Tạo BPMN thất bại. Vui lòng kiểm tra lại.',
  4000601: 'Xóa BPMN thất bại. Vui lòng kiểm tra hoặc thử lại',
  4000602: 'Lỗi hệ thống',
  4000603: 'Lỗi hệ thống',
  4000604: 'Lỗi hệ thống',
  4000605: 'Lỗi hệ thống',
  4000606: 'Lỗi hệ thống',
  4000607: 'Lỗi hệ thống',
  4000608: 'Lỗi hệ thống',
  4000609: 'Cập nhật BPMN thất bại. Vui lòng kiểm tra hoặc thử lại',
  4000610: 'Tạo BPMN thất bại. Vui lòng kiêm tra lại',
  4000611: 'Tên BPMN đã tồn tại',
  4000612: 'Xóa bộ 3 mô tả thất bại',
  4000613: 'Không được bỏ trống tên BPMN',
  4000614: 'Lỗi hệ thống',
  4000615: 'Lỗi hiển thị thông tin bộ ba mô tả. Vui lòng thử lại',
  4000616: 'Tạo BPMN thất bại. Vui lòng kiểm tra và thử lại',
  4000617: 'Lỗi hệ thống',
  4000618: 'Trường filter phải có ít nhất 1 phần tử',
  4000619: 'Lỗi hệ thống',
  4000620: 'Lỗi hệ thống',
  4000621: 'Lỗi hệ thống',
  4000622: 'Không tìm thấy thông tin user. Vui lòng kiểm tra lại hoặc liên hệ với admin',
  4000623: 'Không tìm thấy thông tin thiết bị.',
  4000624: 'Lỗi hệ thống',
  4000625: 'Không được bỏ trống trường cc',
  4000626: 'Ticket chưa có BPMN vui lòng kiểm tra lại',
  4000627: 'Lỗi hệ thống',
  4000628: 'Lỗi hệ thống',
  4000629: 'Đồng bộ lịch sử call thất bại',
  4000630: 'Call thất bại',
  4000631: 'Đồng bộ lịch sử call thất bại',
  4000632: 'Cập nhật nhân viên xử lý thất bại. Vui lòng thử lại',
  4000633: 'Không tìm thấy nhân viên',
  4000634: 'Không có nhân viên với role bạn cần tìm. Vui lòng kiểm tra lại',
  4000635: 'Địa chỉ mail không hợp lệ. Vui lòng thử lại hoặc báo admin',
  4000636: 'Không được bỏ trống trường To và CC',
  4000637: 'ToAdr phải là mail của FPT. Vui lòng kiểm tra và thử lại',
  4000638: 'Lỗi hệ thống',
  4000639: 'Mô tả này đã được tạo BPMN',
  4000640: 'Hãy đảm bảo rằng email bạn điền là hợp lệ',
  4000641: 'Gửi mail thất bại. Vui lòng kiểm tra lại',
  4000642: 'Lỗi hệ thống',
  4000643: 'Lỗi hệ thống',
  4000644: 'Tên BPMN chỉ được phép chứa tối đa 30 ký tự',
  4000645: 'Hãy đảm bảo rằng tên BPMN không có khoảng trắng ở đâu hoặc cuối.',
  4000646: 'Tên BPMN không được chứa ký tự đặc biệt hoặc nhiều khoảng trắng liên tiếp',
  4000647: 'Số điện thoại không hợp lệ',
  4000648: 'Lỗi hệ thống',
  4000649: 'Không được để trống tên rule.',
  4000650: 'Lưu thất bại. Thiếu Start Event, End Event',
  4000651: 'Lưu thất bại. Mỗi BPMN chỉ có 1 start event, end event',
  4000652: 'Lưu thất bại. Kiểm tra lại type trên mỗi task',
  4000653: 'Lưu thất bại. Task chưa được kết nối',
  4000654: 'Lưu thất bại. Task chưa được kết nối',
  4000655: 'Lưu thất bại. Task chưa được kết nối',
  4000656: 'Lưu thất bại. Exclusive, Inclusive gateway đầu ra phải có điều kiện',
  4000657: 'Lưu thất bại. Service task chưa có input',
  4000699: 'Lưu thất bại. User task chưa có input',
  4000658: 'Lưu thất bại. Inclusive gateway phải có 1 flow default , 1 flow điều kiện',
  4000659: 'Lưu thất bại. Parallel gateway phải có một gateway vào và gateway ra',
  4000661: 'Tạo danh sách Escalate thất bại',
  4000662: 'Lỗi hệ thống',
  4000663: 'Lỗi hệ thống',
  4000664: 'Địa chỉ email phải thuộc fpt',
  4000665: 'Lỗi định dạng thời gian, vui lòng kiểm tra và thử lại',
  4000666: 'File không hợp lệ',
  4000667: 'Không được bỏ trống bộ 3 phần tử',
  4000668: 'Lỗi hệ thống',
  4000669: 'Lỗi hệ thống',
  4000670: 'Tạo thông tin người dùng thất bại. Vui lòng kiểm tra và thử lại',
  4000671: 'Lỗi hệ thống',
  4000672: 'Update kịch bản thất bại. Vui lòng kiểm tra và thử lại',
  4000673: 'Lỗi hệ thống',
  4000674: 'Lỗi hệ thống',
  4000675: 'Bộ 3 mô tả đã được tạo BPMN. Vui lòng kiểm tra và thử lại',
  4000676: 'BPMN không tồn tại. Vui lòng kiểm tra lại',
  4000677: 'Lỗi hệ thống',
  4000678: 'Lỗi hệ thống',
  4000679: 'Lỗi hệ thống',
  4000680: 'Lỗi hệ thống',
  4000681: 'Lỗi hệ thống',
  4000682: 'Lỗi hệ thống',
  4000683: 'Lỗi hệ thống',
  4000684: 'Lỗi hệ thống',
  4000685: 'Lỗi hệ thống',
  4000686: 'Cập nhật trạng thái BPMN thất bại',
  4000687: 'Không tìm thấy ID BPMN. Vui lòng thử lại hoặc báo admin',
  4000689: 'Tên Subprocess đã tồn tại',
  4000690: 'Không thể update BPMN khi đang chạy kịch bản',
  4000698: 'Lưu thất bại, kiểm tra lại group trên mỗi task',
  4000703: 'Thông tin đã tồn tại trên hệ thống',
  4000702: 'Công thức đã tồn tại trên hệ thống',
  4010100: 'Xác thực thất bại. Vui lòng kiểm tra lại hoặc báo admin',
  4010101: 'Token hết hạn. Vui lòng kiểm tra lại hoặc báo admin',
  4010102: 'Không tìm thấy thông tin người dùng',
  4010103: 'Token không hợp lệ. Vui lòng kiểm tra lại hoặc báo admin',
  4010104: 'Role đã tồn tại. Vui lòng kiểm tra lại hoặc báo admin',
  4010105: 'Thông tin đã tồn tại. Vui lòng kiểm tra lại',
  4010106: 'Không tìm thấy dữ liệu!',
  4010107: 'Không tìm thấy bản ghi cuộc gọi',
  4010108: 'Không tìm thấy ghi chú cuộc gọi. Vui lòng kiểm tra lại',
  4010109: 'Không tìm thấy thông tin cho role bạn cần tìm. Vui lòng kiểm tra lại',
  4010200: 'Hãy đảm bảo rằng bạn đã nhập đúng số điện thoại',
  4010201: 'Hãy đảm bảo rằng bạn đã nhập đúng số điện thoại',
  4010202: 'Hãy đảm bảo rằng bạn đã nhập đúng số điện thoại',
  4010203: 'IP Phone phải có từ 4 - 7 chữ số',
  4010204: 'Đơn vị không hợp lệ. Vui lòng kiểm tra lại',
  4010205: 'Số IP Phone không hợp lệ',
  4010206: 'Họ và tên không được để trống',
  4010207: 'Họ và tên không được chứa kí tự đặc biệt',
  4010208: 'Đơn vị làm việc không được để trống',
  4010209: 'Đơn vị làm việc không được chứa kí tự đặc biệt',
  4010210: 'SĐT hoặc IP Phone phải nhập 1 trong 2 thông tin',
  4010400: 'Không tìm thấy Ticket. Vui lòng kiểm tra và thử lại',
  4010600: 'Lệnh RPC không khả dụng. Hãy thử lại với CLI',
  4010601: 'Lỗi hệ thống',
  4010602: 'Lỗi hệ thống',
  4010603: 'Phần tử không hợp lệ. Vui lòng kiểm tra lại',
  4010604: 'Lỗi hệ thống',
  4010605: 'Không tìm thấy ID của mail',
  4010606: 'Địa chỉ IP không hợp lệ',
  4010607: 'Không tìm thấy thiết bị. Vui lòng kiểm tra lại',
  4010608: 'Không tìm thấy Ticket. Vui lòng kiểm tra hoặc thử lại',
  4010609: 'Không tìm thấy group mail',
  4010610: 'Không tìm thấy group mail',
  4010611: 'Không tìm thấy BPMN. Vui lòng kiểm tra và thử lại',
  4010612: 'Không tìm thấy Ticket. Vui lòng kiểm tra hoặc thử lại',
  4010613: 'Không tìm thấy id của mail',
  4010614: 'Email không hợp lệ',
  4010615: 'Lỗi hệ thống',
  4010616: 'Không tìm thấy Sub-process của Ticket',
  4030100: 'Account chưa được phân quyền. Vui lòng liên hệ admin',
  4030101: 'Account chưa được phân quyền. Vui lòng liên hệ admin',
  4030102: 'Account chưa được phân quyền. Vui lòng liên hệ admin',
  4030103: 'Account chưa được phân quyền. Vui lòng liên hệ admin',
  4040100: 'Không tìm thấy thông tin',
  4040101: 'URL không hợp lệ. Vui lòng kiểm tra lại',
  4040102: 'Team không tồn tại. Vui lòng kiểm tra lại',
  4040103: 'Role không tồn tại. Vui lòng kiểm tra lại',
  4040104: 'User không tồn tại. Vui lòng kiểm tra hoặc thử lại',
  4040105: 'Ảnh đã bị xóa hoặc không tồn tại. Vui lòng kiểm tra và thử lại',
  4040601: 'User không tồn tại. Vui lòng kiểm tra hoặc thử lại',
  4040602: 'Email không tồn tại. Vui lòng kiểm tra hoặc thử lại',
  4040607: 'Chưa có phụ lục SLA',
  4230000: 'Update thành công',
  4230001: 'Cập nhạt nhân viên xử lý thành công',
  4230002: 'Queue không tồn tại',
  4230003: 'Cập nhật queue thất bại. Vui lòng kiểm tra hoặc thử lại',
  4230004: 'Cập nhật trạng thái thất bại. Vui lòng kiểm tra hoặc thử lại',
  4230005: 'Upload file thất bại. Vui lòng kiểm tra hoặc thử lại',
  4230006: 'Download file thất bại. Vui lòng kiểm tra hoặc thử lại',
  4230007: 'Chỉ cho phép tối đa 5 điều kiện',
  4230008: 'Tên điều kiện đã tồn tại',
  4230009: 'Điều kiện không tồn tại. Vui lòng kiểm tra hoặc thử lại',
  4230010: 'Xóa hoặc cập nhật điều kiện thất bại. Vui lòng kiểm tra hoặc thử lại',
  40006100: 'Lưu thất bại, BPMN/subprocess tối thiểu phải có 1 task',
  5000101: 'Tạo team mới thất bại. Vui lòng kiểm tra hoặc thử lại',
  5000103: 'Xóa team thất bại. Vui lòng kiểm tra hoặc thử lại',
  5000105: 'Xóa thông tin người dùng thất bại. Vui lòng kiểm tra hoặc thử lại',
  5000106: 'Upload file thất bại. Vui lòng kiểm tra hoặc thử lại',
  5000107: 'File không tồn tại. Vui lòng kiểm tra lại URL',
  5000501: 'Kết nối với RR thất bại. Vui lòng kiểm tra hoặc thử lại',
  5000502: 'Kết nối đến thiết bị thất bại. Vui lòng kiểm tra hoặc thử lại',
  5000601: 'Cập nhật nhân viên xử lý thất bại. Vui lòng kiểm tra hoặc thử lại',
  5000602: 'Filter không thành công. Vui lòng kiểm tra hoặc thử lại',
  5000603: 'Không thể gộp Ticket, Hãy đảm bảo không có ticket nào ở trạng thái Reject hay Closed',
  5000604: 'Không thể Resolve Ticket khi chưa checkback',
  5000605: 'Không thể close Ticket khi chưa checkback',
  5000606: 'Bạn không thể close Ticket khi hệ thống vẫn còn cảnh báo',
  6000600: 'Lỗi hệ thống. Vui lòng F5 hoặc báo admin',
  6000601: 'User không tồn tại. Vui lòng kiểm tra hoặc thử lại',
  6000602: 'Cập nhật nhân viên xử lý thất bại. Vui lòng kiểm tra hoặc thử lại',
  6000603: 'Cập nhật trạng thái ticket thất bại. Vui lòng kiểm tra hoặc thử lại',
  6000604: 'Ticket không có BPMN. Vui lòng kiểm tra hoặc thử lại',
  6000605: 'Ticket không có nhân viên xử lý. Vui lòng kiểm tra lại',
  6000608: 'Gửi mail thất bại. Vui lòng kiểm tra hoặc thử lại',
  6000609: 'Xóa thông báo thất bại',
  6000610: 'Cập nhật thông báo thất bại. Vui lòng kiểm tra hoặc thử lại',
  6000612: 'Cập nhật trạng thái thông báo thất bại. Vui lòng kiểm tra hoặc thử lại',
  6000617: 'Chỉ có phép tối đa 10 ký tự',
  6000618: 'Tên điều kiện không hợp lệ. Vui lòng kiểm tra hoặc thử lại',
  6000619: 'Điều kện không hợp lệ. Vui lòng kiểm tra hoặc thử lại',
};

export { errorCode };
